import Conexion_api from "@/api/Conexion_api.js";
    /**
     * Verifica que el subdominio de la url sea uno registrado en una base en caso de serlo
     * retorna true y en caso de no serlo retorna false 
    */
const validar_subdominio = (subdominio,navegacion) => {
    return new Promise((resolver, rechazar) => {
        Conexion_api({
            body: {
              subdominio: String(subdominio),
              navigator:navegacion
            },
            evento: "login/validar_subdomino"
          }).then(respuesta => {
              if(respuesta.data.error) {
                console.error(respuesta.data.error)
              } else {           
                resolver(respuesta.data.datos)      
              }  
                           
          }).catch(err => {
              err = String(err)
              rechazar(err)
              console.error(err)
          }) 
    });
}

export {
    validar_subdominio
}